import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isIfasRole } from "../utils/portal";
import { useAuthStore } from "../store/useAuthStore";
import { useUserStore } from "../store/useUserStore";
import { useSessionStore } from "../store/useSessionStore";

/**
 * Sets the browser tab title based on context. Purely cosmetic — it only
 * writes document.title and renders nothing. The favicon is a single shared
 * icon (workspace-favicon.svg) set statically in public/index.html.
 *
 * - Admin login pages: "Claims Admin Login" / "Funeral Service Admin Login"
 * - Signed-in IFAS users: "Funeral Service"
 * - Everything else (Claims, signed-out): "Claim Service"
 */
export default function DocumentTitle() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const role = useUserStore((state) => state.role);
  const userRole = useSessionStore((state) => state.userRole);

  useEffect(() => {
    const path = location.pathname;
    let title = "Claim Service";

    if (path.startsWith("/admin/login")) {
      const portal = new URLSearchParams(location.search).get("portal");
      title =
        portal === "ifas" ? "Funeral Service Admin Login" : "Claims Admin Login";
    } else {
      const effectiveRole = userRole || role;
      title =
        isAuthenticated && isIfasRole(effectiveRole)
          ? "Funeral Service"
          : "Claim Service";
    }

    document.title = title;
  }, [location, isAuthenticated, role, userRole]);

  return null;
}
